module.exports = __webpack_public_path__ + "media/src/assets/Images/Scotiabank-a13f81ea10b4c0168e2830dfd3344d12.svg";